import { render, staticRenderFns } from "./TermsOfUsePage.vue?vue&type=template&id=71c1fd22&scoped=true&"
import script from "./TermsOfUsePage.vue?vue&type=script&lang=js&"
export * from "./TermsOfUsePage.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUsePage.vue?vue&type=style&index=0&id=71c1fd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1fd22",
  null
  
)

export default component.exports